export interface Author {
  slug: string;
  name: string;
  jobTitle: string;
  company: string;
  location: string;
  photo: string;
  bio: string;
  favoriteTopics: string[];
  social: {
    linkedin?: string;
    facebook?: string;
    instagram?: string;
  };
}

export const authors: Author[] = [
  {
    slug: 'dan-west',
    name: 'Dan West',
    jobTitle: 'Project Manager',
    company: 'Tytum',
    location: 'San Diego, CA',
    photo: '/authors/dan-west.jpg',
    bio: 'A customer focused Project Manager in the HVAC industry with a proven track record of delivering projects on time and within budget. Known for clear communication, responsiveness, and a commitment to understanding client needs. Brings a practical approach and clear vision to every project, ensuring a smooth process and high quality results that meet customer expectations.',
    favoriteTopics: ['HVAC Repair', 'HVAC Installation'],
    social: {},
  },
];

export function getAuthorBySlug(slug: string): Author | undefined {
  return authors.find((a) => a.slug === slug);
}

export function getAuthorByName(name: string): Author | undefined {
  return authors.find((a) => a.name === name);
}
